/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion, max-lines-per-function */

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../translations';

import { ReceptionServiceCreateForm, ReceptionServiceCreateFormLoader } from './ReceptionServiceCreateForm';
import { ReceptionServiceCreateAction } from './ReceptionServiceCreateModal.actions';

type ReceptionServiceCreateModalProps = {
   readonly onClose: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const ReceptionServiceCreateModal = (props: ReceptionServiceCreateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'receptionServiceCreate'}
         title={receptionServiceTranslationKeys.create.modal.title}
         width={ModalWidth.HUGE}
      >
         <ReceptionServiceCreateFormLoader>
            {({ practitioners, serviceLocations }) => (
               <ReceptionServiceCreateForm practitioners={practitioners} serviceLocations={serviceLocations}>
                  {({ handleSubmit, formState, reset, setNotUniqueReceptionServiceNameError }) => (
                     <>
                        <ReceptionServiceCreateAction
                           onSuccess={reset}
                           onReceptionServiceAlreadyExistsFault={setNotUniqueReceptionServiceNameError}
                        >
                           {({ createReceptionService }) => (
                              <ModalConfirmButton
                                 label={receptionServiceTranslationKeys.create.modal.confirmAndCreateNext}
                                 onClick={handleSubmit(createReceptionService)}
                                 variant={ButtonVariant.SECONDARY}
                                 testId={'confirmAndCreateNext'}
                              />
                           )}
                        </ReceptionServiceCreateAction>
                        <ReceptionServiceCreateAction
                           onSuccess={props.onSuccess}
                           onReceptionServiceAlreadyExistsFault={setNotUniqueReceptionServiceNameError}
                        >
                           {({ createReceptionService }) => (
                              <ModalConfirmButton
                                 label={receptionServiceTranslationKeys.create.modal.confirm}
                                 onClick={handleSubmit(createReceptionService)}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           )}
                        </ReceptionServiceCreateAction>
                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.onClose}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.onSuccess} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </ReceptionServiceCreateForm>
            )}
         </ReceptionServiceCreateFormLoader>
      </Modal>
   );
};
